import store from "../init/store.js";

export function getColoredUseLine(
  combatantId = "",
  actionName = "",
  article = "",
  shouldPause = true
) {
  //Create a space if there is a word before the actionName
  const space = article.length ? " " : "";

  if (shouldPause) {
    return {
      type: "message",
      content: [
        getColoredNameById(combatantId),
        ` uses `,
        "@@pause_300@@",
        `[FAST]${article}${space}${actionName}!`
      ]
    };
  }
  //No pause
  return {
    type: "message",
    content: [
      getColoredNameById(combatantId),
      ` uses `,
      `${article}${space}${actionName}!`
    ]
  };
}

//Get colored name. Red for enemy, Blue for friendly
//For Battle // TODO: future uses of this might need some more customization

export function getColoredNameById(combatantId) {
  const { combatants, battlePlayerId } = store.getState().battle;

  //In cases where no human player is playing, just return the name with no color!
  if (!Object.keys(combatants).find(combId => combId === battlePlayerId[0])) {
    return combatants[combatantId].name;
  }

  //Encode a string that has the combatant's teamId baked in.
  // `convert-speech-to-textLine-array` will handle decoding `COLORVAR_NAME_FROM_TEAM::XXXXX` strings.
  const colorPresetString = `COLORVAR_NAME_FROM_TEAM::${combatants[combatantId]
    .belongsToTeam}`;

  return `@@color_${colorPresetString}@@${combatants[combatantId].name.toUpperCase()}`;
}



// WEBPACK FOOTER //
// ./src/helpers/rollout-message-text-helpers.js